import React, { useContext, useEffect, useRef, useState } from 'react';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import AddProduct from './AddProduct';
import { add_product_api, fetch_product, fetch_stock, update_product_api, update_stock_api } from '../api/api';
import api from '../api/url';
import { Upload } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { MyContext } from '../context/Context';
import Loader from '../Loader/Loader';
import FormError from '../components/FormError';

function Product() {
    const total_stock_Ref = useRef();
    const new_stock_Ref = useRef();
    const product_name_ref = useRef(null);
    const update_product_close_Ref = useRef(null);
    const manage_stock_close_Ref = useRef(null);
    const [fileListThumb, setFileLisThumb] = useState([]);

    const [fileListImg0, setFileListImg0] = useState([]);
    const [fileListImg1, setFileListImg1] = useState([]);
    const [fileListImg2, setFileListImg2] = useState([]);
    const [fileListImg3, setFileListImg3] = useState([]);

    const [manageStock, setManageStock] = useState({
        current_stock: "",
        new_stock: "",
        total_stock: "",
        display_stock: "",
        description: ""
    });
    const [formError, setFormError] = useState({
        item_name: "",
        item_price: "",
        new_stock: '',
        thumbnail_image: "",
        image_0: "",
        image_1: "",
        image_2: "",
        image_3: "",
    })
    const [product, setProduct] = useState({
        item_name: "",
        item_price: "",
        item_description: "",
        thumbnail_image: "",
        image_0: "",
        image_1: "",
        image_2: "",
        image_3: "",
    });
    const [productTempData, setProductTempData] = useState({
        item_name: "",
        item_price: "",
        item_description: "",
        thumbnail_image: "",
        image_0: "",
        image_1: "",
        image_2: "",
        image_3: "",
    });
    const [noProduct, setNOProduct] = useState(false);
    const { loader, setLoader } = useContext(MyContext);

    // console.log(product)

    useEffect(() => {
        fetch_product_api_call();
        // fetch_stock_api_call();
    }, []);

    // fetch products
    const fetch_product_api_call = async () => {
        setLoader(true);
        try {
            const res = await fetch_product();
            if (res.status === 200 && res.data.data.length > 0) {
                const fetchedProduct = res.data.data[0];
                setProduct(fetchedProduct);
                setProductTempData(fetchedProduct)
                // Update fileListThumb and fileListThumb2 with existing images
                if (fetchedProduct.thumbnail_image) {
                    setFileLisThumb([
                        {
                            uid: '-1',
                            name: 'thumbnail.png',
                            status: 'done',
                            url: `${api.imageUrl}${fetchedProduct.thumbnail_image}`,
                        },
                    ]);
                }
                if (fetchedProduct.image_0) {
                    setFileListImg0([
                        {
                            uid: '-1',
                            name: 'image_0.png',
                            status: 'done',
                            url: `${api.imageUrl}${fetchedProduct.image_0}`,
                        },
                    ]);
                }
                if (fetchedProduct.image_1) {
                    setFileListImg1([
                        {
                            uid: '-1',
                            name: 'image_1.png',
                            status: 'done',
                            url: `${api.imageUrl}${fetchedProduct.image_1}`,
                        },
                    ]);
                }
                if (fetchedProduct.image_2) {
                    setFileListImg2([
                        {
                            uid: '-1',
                            name: 'image_2.png',
                            status: 'done',
                            url: `${api.imageUrl}${fetchedProduct.image_2}`,
                        },
                    ]);
                }
                if (fetchedProduct.image_3) {
                    setFileListImg3([
                        {
                            uid: '-1',
                            name: 'image_3.png',
                            status: 'done',
                            url: `${api.imageUrl}${fetchedProduct.image_3}`,
                        },
                    ]);
                }
            }
            setLoader(false);
        } catch (error) {
            console.error("Error fetching product:", error);
        }
    };


    // change handle
    const change_handle = (e) => {
        const { name, value, files } = e.target;
        setProduct({
            ...product,
            [name]: files && files.length > 0 ? files[0] : value,
        });
    };


    // update product
    const update_product_api_call = async () => {
        const { item_name, item_price } = product;

        const errors = {};

        if (!item_name) {
            errors.item_name = 'Please enter product name!';
        }
        if (!item_price) {
            errors.item_price = 'Please enter Product price!';
        }
        if (fileListThumb.length === 0) {
            errors.thumbnail_image = 'Please upload an image!';
        }
        // if (fileListImg0.length === 0) {
        //     errors.image_0 = 'Please upload an image!';
        // }
        // if (fileListImg1.length === 0) {
        //     errors.image_1 = 'Please upload an image!';
        // }
        // if (fileListImg2.length === 0) {
        //     errors.image_2 = 'Please upload an image!';
        // }
        // if (fileListImg3.length === 0) {
        //     errors.image_3 = 'Please upload an image!';
        // }
        setFormError(errors);

        if (Object.keys(errors).length !== 0) {
            return;
        }

        const formData = new FormData();
        formData.append("product_id", product.product_id);
        formData.append("item_name", product.item_name);
        formData.append("item_price", product.item_price);
        formData.append("item_description", product.item_description);

        if (product.thumbnail_image) {
            formData.append("thumbnail_image", product.thumbnail_image);
        }
        if (product.image_0) {
            formData.append("image_0", product.image_0);
        }
        if (product.image_1) {
            formData.append("image_1", product.image_1);
        }
        if (product.image_2) {
            formData.append("image_2", product.image_2);
        }
        if (product.image_3) {
            formData.append("image_3", product.image_3);
        }

        try {
            const res = await update_product_api(formData);
            if (res.status === 200) {
                console.log(res.data.data)
                toast.success("Product updated successfully");
                update_product_close_Ref.current.click();
                fetch_product_api_call();
            }
        } catch (error) {
            console.error("Error updating product:", error);
        }
    };


    // upload thumbnails
    const uploadButton = (
        <button style={{ border: 0, background: "none" }} type="button">
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
        </button>
    );

    // thubnail image 
    const thumb_Before_upload = (file) => {
        const isImage = file.type.startsWith("image/");
        const isLt3M = file.size / 1024 / 1024 < 3;
        if (!isImage || !isLt3M) {
            return Upload.LIST_IGNORE;
        }
        file.url = URL.createObjectURL(file);
        setProduct({
            ...product,
            thumbnail_image: file,
        });
        setFileLisThumb([file]);
        return false;
    };



    // upload image_0
    const image_0_Before_upload = (file) => {
        const isImage = file.type.startsWith("image/");
        const isLt3M = file.size / 1024 / 1024 < 3;
        if (!isImage || !isLt3M) {
            return Upload.LIST_IGNORE;
        }
        file.url = URL.createObjectURL(file);
        setProduct({
            ...product,
            image_0: file,
        });
        setFileListImg0((prevList) => [...prevList, file]);
        return false;
    };

    // upload image_1
    const image_1_Before_upload = (file) => {
        const isImage = file.type.startsWith("image/");
        const isLt3M = file.size / 1024 / 1024 < 3;
        if (!isImage || !isLt3M) {
            return Upload.LIST_IGNORE;
        }
        file.url = URL.createObjectURL(file);
        setProduct({
            ...product,
            image_1: file,
        });
        setFileListImg1((prevList) => [...prevList, file]);
        return false;
    };

    // upload image_2
    const image_2_Before_upload = (file) => {
        const isImage = file.type.startsWith("image/");
        const isLt3M = file.size / 1024 / 1024 < 3;
        if (!isImage || !isLt3M) {
            return Upload.LIST_IGNORE;
        }
        file.url = URL.createObjectURL(file);
        setProduct({
            ...product,
            image_2: file,
        });
        setFileListImg2((prevList) => [...prevList, file]);
        return false;
    };

    // upload image_3
    const image_3_Before_upload = (file) => {
        const isImage = file.type.startsWith("image/");
        const isLt3M = file.size / 1024 / 1024 < 3;
        if (!isImage || !isLt3M) {
            return Upload.LIST_IGNORE;
        }
        file.url = URL.createObjectURL(file);
        setProduct({
            ...product,
            image_3: file,
        });
        setFileListImg3((prevList) => [...prevList, file]);
        return false;
    };



    const onChangeThumb = ({ fileList }) => {
        setFileLisThumb(fileList);
    };

    const onChangeImage0 = ({ fileList }) => {
        setFileListImg0(fileList);
        console.log(fileList.length)
    };
    const onChangeImage1 = ({ fileList }) => {
        setFileListImg1(fileList);
        console.log(fileList)
    };
    const onChangeImage2 = ({ fileList }) => {
        setFileListImg2(fileList);
        console.log(fileList)
    };
    const onChangeImage3 = ({ fileList }) => {
        setFileListImg3(fileList);
        console.log(fileList)
    };


    // fetch stock 
    const fetch_stock_api_call = async () => {

        try {
            new_stock_Ref.current.value = ""
            const res = await fetch_stock();
            if (res.status === 200) {
                setManageStock({
                    ...manageStock,
                    current_stock: res.data.data[0].new_stock,
                    total_stock: res.data.data[0].new_stock,
                    display_stock: res.data.data[0].new_stock,
                    new_stock: "",
                    description: "",
                });

                if (res.data.data.length < 1) {
                    setNOProduct(true);
                }
            }

        } catch (error) {
            console.error("Error fetching stock:", error);
        }
    };


    // update stock
    const update_stock_api_call = async () => {

        const errors = {};
        if (!manageStock.new_stock) {
            errors.new_stock = 'Please enter the new stock!'
        }
        setFormError(errors);

        if (Object.keys(errors).length !== 0) {
            return;
        }
        try {
            const data = {
                new_stock: manageStock.total_stock,
                last_stock: manageStock.current_stock,
                item_price: product.item_price,
                description: manageStock.description
            }

            const res = await update_stock_api(data);
            if (res.status === 200) {
                fetch_product_api_call();
                toast.success("Stock Update Successfully");
                manage_stock_close_Ref.current.click();
                setManageStock({
                    current_stock: "",
                    new_stock: "",
                    total_stock: "",
                    description: ""
                })
            }
        } catch (error) {
            console.error("Error updating stock:", error);
            toast.error("Error updating stock");
        }
    };


    const clearError = () => {
        const clearedErrors = {};

        Object.keys(formError).forEach(field => {
            clearedErrors[field] = "";
        });

        setFormError(clearedErrors);
    }

    return (
        <div className="wrapper">
            <Navbar />
            <Sidebar />
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12 d-flex flex-column flex-sm-row justify-content-between">
                                <h1 className="m-0">Product</h1>
                                <span className='text-sm d-flex justify-content-end mt-4 mb- mt-sm-0 mb-sm-0'>
                                    <Link to="/dashboard">Dashboard</Link>
                                    <span className='ml-1 mr-1'>/</span>
                                    <span>Product</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                {
                    loader ? <Loader /> :
                        (
                            <section className="content">
                                {noProduct ? (
                                    <AddProduct />
                                ) : (
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="card" style={{ width: '300px' }}>
                                                    <img
                                                        src={productTempData.thumbnail_image instanceof File ? productTempData.thumbnail_image.url : `${api.imageUrl}${productTempData.thumbnail_image}`}
                                                        alt="product thumbnail"
                                                    />
                                                    <div className="card-body">
                                                        <span className='d-flex justify-content-between'>
                                                            <h5 className="card-title">{productTempData.item_name}</h5>
                                                            <span className="text-success">Stock: {productTempData.current_stock}</span>
                                                        </span>
                                                        <p className="card-text text-success mb-0">{`₹ ${productTempData.item_price}`}</p>
                                                        <p className="card-text product-desc">
                                                            <small className="text-muted">{productTempData.item_description}</small>
                                                        </p>
                                                    </div>
                                                    <div className='action d-flex justify-content-between pr-3 pl-3 pb-3 pt-1'>
                                                        <button
                                                            type='button'
                                                            className='btn btn-naariyal-green'
                                                            data-toggle="modal"
                                                            data-backdrop="static"
                                                            data-target="#update-product"
                                                        >
                                                            Update
                                                        </button>
                                                        <button
                                                            type='button'
                                                            className='btn btn-info'
                                                            data-toggle="modal"
                                                            data-backdrop="static"
                                                            data-target="#manage-stock"
                                                            onClick={() => {
                                                                
                                                                setManageStock({...manageStock,current_stock: productTempData.current_stock})
                                                                // fetch_stock_api_call();
                                                            }}
                                                        >
                                                            Manage Stock
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}


                                {/* update product modal */}
                                <div className="modal fade p-0" id="update-product" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header border-0">
                                                <h5 className="modal-title">Update Product</h5>
                                                <button type="button" onClick={() => {
                                                    clearError();
                                                    // fetch_product_api_call();
                                                    // fetch_stock_api_call();
                                                }} className="close" data-dismiss="modal" aria-label="Close" ref={update_product_close_Ref}>
                                                    <span aria-hidden="true">×</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <form className="container-fluid" autoComplete="off">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="card card-primary" style={{ boxShadow: "0 0 0" }}>
                                                                <div className="card-body">
                                                                    <div className="row">
                                                                        <div className="col-6">
                                                                            <div className="form-group">
                                                                                <label htmlFor="inputName">Product Name</label>
                                                                                <input
                                                                                    type="text"
                                                                                    id="inputName"
                                                                                    className="form-control"
                                                                                    placeholder="Enter Product Name"
                                                                                    autoFocus
                                                                                    ref={product_name_ref}
                                                                                    name="item_name"
                                                                                    value={product.item_name}
                                                                                    onChange={change_handle}
                                                                                />
                                                                                <FormError>
                                                                                    {formError.item_name ? formError.item_name : ''}
                                                                                </FormError>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <div className="form-group">
                                                                                <label htmlFor="inputPrice">Product Price</label>
                                                                                <input
                                                                                    type="number"
                                                                                    id="inputPrice"
                                                                                    className="form-control"
                                                                                    placeholder="Enter Product Price"
                                                                                    name="item_price"
                                                                                    value={product.item_price}
                                                                                    onChange={change_handle}
                                                                                />
                                                                                <FormError>
                                                                                    {formError.item_price ? formError.item_price : ''}
                                                                                </FormError>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <div className="form-group">
                                                                                <label htmlFor="inputDescription">Product Description</label>
                                                                                <textarea
                                                                                    id="inputDescription"
                                                                                    className="form-control"
                                                                                    // rows="4"
                                                                                    style={{ minHeight: "110px" }}
                                                                                    placeholder="Enter Product Description"
                                                                                    name="item_description"
                                                                                    value={product.item_description}
                                                                                    onChange={change_handle}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <label>Thumbnail Image</label>
                                                                            <Upload
                                                                                beforeUpload={thumb_Before_upload}
                                                                                listType="picture-card"
                                                                                fileList={fileListThumb}
                                                                                onChange={onChangeThumb}
                                                                            >
                                                                                {fileListThumb.length >= 1 ? null : uploadButton}
                                                                            </Upload>
                                                                            <FormError>
                                                                                {formError.thumbnail_image ? formError.thumbnail_image : ''}
                                                                            </FormError>
                                                                        </div>

                                                                        <div className="col-12">

                                                                            <div className="row">
                                                                                <label className='col-12'>Thumbnail Image</label>
                                                                                <span className="col-6 col-sm-4 col-lg-3 mb-3">
                                                                                    <Upload
                                                                                        beforeUpload={image_0_Before_upload}
                                                                                        listType="picture-card"
                                                                                        fileList={fileListImg0}
                                                                                        onChange={onChangeImage0}
                                                                                    >
                                                                                        {fileListImg0.length >= 1 ? null : uploadButton}
                                                                                    </Upload>
                                                                                    {/* <FormError>
                                                                                        {formError.image_0 ? formError.image_0 : ''}
                                                                                    </FormError> */}
                                                                                </span>
                                                                                <span className="col-6 col-sm-4 col-lg-3 mb-3">
                                                                                    <Upload
                                                                                        beforeUpload={image_1_Before_upload}
                                                                                        listType="picture-card"
                                                                                        fileList={fileListImg1}
                                                                                        onChange={onChangeImage1}
                                                                                    >
                                                                                        {fileListImg1.length >= 1 ? null : uploadButton}
                                                                                    </Upload>
                                                                                    {/* <FormError>
                                                                                        {formError.image_1 ? formError.image_1 : ''}
                                                                                    </FormError> */}
                                                                                </span>
                                                                                <span className="col-6 col-sm-4 col-lg-3 mb-3">
                                                                                    <Upload
                                                                                        beforeUpload={image_2_Before_upload}
                                                                                        listType="picture-card"
                                                                                        fileList={fileListImg2}
                                                                                        onChange={onChangeImage2}
                                                                                    >
                                                                                        {fileListImg2.length >= 1 ? null : uploadButton}
                                                                                    </Upload>
                                                                                    {/* <FormError>
                                                                                        {formError.image_2 ? formError.image_2 : ''}
                                                                                    </FormError> */}
                                                                                </span>
                                                                                <span className="col-6 col-sm-4 col-lg-3 mb-3">
                                                                                    <Upload
                                                                                        beforeUpload={image_3_Before_upload}
                                                                                        listType="picture-card"
                                                                                        fileList={fileListImg3}
                                                                                        onChange={onChangeImage3}
                                                                                    >
                                                                                        {fileListImg3.length >= 1 ? null : uploadButton}
                                                                                    </Upload>
                                                                                    {/* <FormError>
                                                                                        {formError.image_3 ? formError.image_3 : ''}
                                                                                    </FormError> */}
                                                                                </span>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-naariyal-green mr-auto ml-auto mt-2 w-50"
                                                                    onClick={update_product_api_call}
                                                                >
                                                                    Update Product
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* manage stock modal */}
                                <div className="modal fade" id="manage-stock" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header border-0">
                                                <h5 className="modal-title">Manage Stock</h5>
                                                <button type="button"
                                                    className="close"
                                                    data-dismiss="modal"
                                                    aria-label="Close"
                                                    onClick={() => {
                                                        clearError();
                                                    }}
                                                    ref={manage_stock_close_Ref}>
                                                    <span aria-hidden="true"
                                                    >
                                                        ×
                                                    </span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <form className="container-fluid" autoComplete="off">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="card card-primary" style={{ boxShadow: "0 0 0" }}>
                                                                <div className="card-body">
                                                                    <div className='mb-3 mx-sm-3'>
                                                                        <label htmlFor="total-stock">Description</label>
                                                                        <div>
                                                                            <input
                                                                                type="text"
                                                                                placeholder='optional'
                                                                                className='form-control input-width'
                                                                                value={manageStock.description}
                                                                                onChange={(e) => setManageStock({
                                                                                    ...manageStock,
                                                                                    description: e.target.value
                                                                                })}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="row d-flex align-items-end justify-content-around">
                                                                        <div className="col-sm-3">
                                                                            <label htmlFor="current-stock">Current Stock</label>
                                                                            <div>
                                                                                <input
                                                                                    type="number"
                                                                                    id="current-stock"
                                                                                    value={manageStock.current_stock}
                                                                                    className='form-control input-width'
                                                                                    disabled
                                                                                />
                                                                            </div>

                                                                        </div>


                                                                        <div className='col-0 mb-2 mt-2 mt-sm-0'>
                                                                            +
                                                                        </div>

                                                                        <div className="col-sm-3">
                                                                            <label htmlFor="new-stock">New Stock</label>
                                                                            <div>
                                                                                <input
                                                                                    type="number"
                                                                                    id="new-stock"
                                                                                    className='form-control input-width'
                                                                                    placeholder='0'
                                                                                    ref={new_stock_Ref}
                                                                                    onChange={(e) => setManageStock({
                                                                                        ...manageStock,
                                                                                        new_stock: e.target.value,
                                                                                        total_stock: parseInt(manageStock.current_stock) + parseInt(e.target.value) || ""
                                                                                    })}
                                                                                />
                                                                            </div>
                                                                        </div>

                                                                        <div className='col-0 mb-2 mt-2 mt-sm-0'>
                                                                            =
                                                                        </div>

                                                                        <div className="col-sm-3">
                                                                            <label htmlFor="total-stock">Total Stock</label>
                                                                            <div>
                                                                                <input
                                                                                    type="number"
                                                                                    id="total-stock"
                                                                                    className='form-control input-width'
                                                                                    ref={total_stock_Ref}
                                                                                    value={parseInt(manageStock.current_stock) + parseInt(manageStock.new_stock) || manageStock.current_stock}
                                                                                    onChange={(e) => setManageStock({
                                                                                        ...manageStock,
                                                                                        total_stock: e.target.value
                                                                                    })}
                                                                                    disabled
                                                                                />
                                                                            </div>
                                                                        </div>

                                                                    </div>

                                                                </div>
                                                                <div className='text-center'>
                                                                    <FormError>
                                                                        {formError.new_stock ? formError.new_stock : ''}
                                                                    </FormError>
                                                                </div>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-naariyal-green mr-auto ml-auto mt-2 w-25"
                                                                    onClick={update_stock_api_call}
                                                                >
                                                                    Save
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </section>
                        )
                }
            </div >
            <Footer />
        </div >
    );
}

export default Product;
